import { useContext, useMemo } from 'react';
import { createStateContext, withStateContext } from '../../../common';
import { useProductSearchReducer } from '../reducers';
import { initialProductSearchState } from '../states';
import { jsx as _jsx } from "react/jsx-runtime";
var ProductSearchContext = createStateContext(initialProductSearchState);
var useProductSearchContext = function () { return useContext(ProductSearchContext); };
function ProductSearchProvider(_a) {
    var children = _a.children;
    var _b = useProductSearchReducer(), state = _b.state, dispatch = _b.dispatch;
    var providerState = useMemo(function () { return ({ state: state, dispatch: dispatch }); }, [state, dispatch]);
    return /*#__PURE__*/ _jsx(ProductSearchContext.Provider, { value: providerState, children: children });
}
function withProductSearchContext(Component) { return withStateContext(ProductSearchProvider, Component); }
export { ProductSearchContext, ProductSearchProvider, useProductSearchContext, withProductSearchContext };
